export class RegexFilterClasses {

    /**
     * Additional root-class when using the preview.
     */
    static readonly previewRoot = "ic3RegexFilter-previewRoot";

    /**
     * Additional root-class when using the selection box.
     */
    static readonly selectionBoxRoot = "ic3RegexFilter-selectionBoxRoot";

    /**
     * Class for the div with the search box.
     */
    static readonly searchBoxContainer = "ic3RegexFilter-searchBoxContainer";

    static readonly reachedLimitText = "ic3RegexFilter-reachedLimitText";

    static readonly filterPreview = "ic3RegexFilter-filterPreview";

    static readonly searchContent = "ic3RegexFilter-searchContent";

    static readonly footer = "ic3RegexFilter-footer";

    static readonly footerButtons = "ic3RegexFilter-footerButtons";

    static readonly filterCount = "ic3RegexFilter-filterCount";

    static readonly selectResultsButton = "ic3RegexFilter-selectResultsButton";
}

export declare type RegexFilterClassesKey = keyof RegexFilterClasses;

export interface RegexFilterProps {

}